<template>
  <Section>
    <template #header>
      <div class="flex items-center gap-2 text-dark-neutral-500">
        <span class="material-symbols-outlined">interests</span>
        <h2 class="font-semibold">Operators</h2>
      </div>
    </template>

    <div class="px-6 py-4 flex flex-wrap gap-4 w-full">
      <div
        v-for="(op, index) in operators"
        :key="index"
        class="border rounded-lg border-mid-neutral-50 p-4 w-96 flex flex-col gap-7"
      >
        <a :href="op.url" target="_blank" rel="noopener noreferrer">
          <img
            :src="getFavicon(op.url)"
            alt="Operator logo"
            class="w-12 h-12"
          />
        </a>
        <div>
          <h3 class="text-xl font-semibold text-dark-neutral-600">
            {{ op.name }}
          </h3>
          <p class="text-sm text-mid-neutral-500">{{ op.address }}</p>
        </div>
      </div>
    </div>
  </Section>
</template>

<script setup lang="ts">
import Section from "components/Section.vue";

const operators = [
  {
    name: "Stryker",
    url: "https://www.stryker.com",
    address: "2825 Airview Blvd, Kalamazoo, MI 49002, USA",
  },
  {
    name: "Becton Dickinson",
    url: "https://www.bd.com",
    address: "1 Becton Drive, Franklin Lakes, NJ 07417, USA",
  },
  {
    name: "Zimmer Biomet Holdings",
    url: "https://www.zimmerbiomet.com",
    address: "345 East Main St, Warsaw, IN 46580, USA",
  },
];

function getFavicon(siteUrl: string) {
  try {
    const urlObj = new URL(siteUrl);
    return `${urlObj.origin}/favicon.ico`;
  } catch {
    return "";
  }
}
</script>
